<div class="row" [class.disabled]="disabled || selected" (click)="onCouponClicked()">
  <ng-container *ngIf="loading; else loaded" [ngTemplateOutlet]="loader"></ng-container>
</div>

<ng-template #loader>
  <div *ngIf="loading" class="flex flex-col items-center justify-center flex-grow">
    <mat-spinner [diameter]="24"></mat-spinner>
  </div>
</ng-template>

<ng-template #loaded>
  <ng-container *ngIf="coupon; else noCoupon" [ngTemplateOutlet]="validCoupon"></ng-container>
</ng-template>

<ng-template #validCoupon>
  <app-icon name="redeem" color="#619900" class="redeem-icon"></app-icon>
  <div class="flex flex-col">
    <div class="amount">{{ coupon?.amount | number: '1.2-2':'pl' }}&nbsp;zł</div>
    <div>Ważny do: {{ coupon?.expirationDate ? (coupon.expirationDate | date: datePattern:'':'pl') : '...' }}</div>
  </div>
  <app-icon *ngIf="selected" name="check" class="check-icon" color="#ff6200"></app-icon>
</ng-template>

<ng-template #noCoupon>
  <app-icon name="redeem" color="#CECECE" class="redeem-icon"></app-icon>
  <div class="flex flex-col">
    <div class="amount">Brak</div>
    <div>Skorzystam innym razem</div>
  </div>
  <app-icon *ngIf="selected" name="check" class="check-icon" color="#ff6200"></app-icon>
</ng-template>
